const imageExtensions = ['JPG', 'JPEG', 'PNG', 'SVG+XML', 'GIF', 'IMAGE'];

const isImage = (type: string) => type?.includes?.('image');

const isVideo = (type: string) => type?.includes?.('video');

const isPdf = (type: string) => type?.includes?.('pdf');

const isDocx = (type: string) =>
  type?.includes?.('application/vnd.openxmlformats-officedocument.wordprocessingml.document') ||
  type?.includes?.('application/vnd.ms-excel') ||
  type?.includes?.('application/vnd.ms-powerpoint') ||
  type?.includes?.('application/vnd.openxmlformats-officedocument.presentationml.presentation') ||
  type?.includes?.('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
  type?.includes?.('application/msword');

export { imageExtensions, isImage, isVideo, isPdf, isDocx };
